import { Recipient } from '@bonusly/recipient-entities';

export const createRecipientContent = (recipients: Recipient[]) => {
	if (!recipients.length) {
		return null;
	}

	const content: any = [];
	recipients.forEach((recipient: any) => {
		content.push({
			type: 'recipient',
			attrs: {
				id: recipient.id,
				record: recipient,
			},
		});
		// add a space after recipient
		content.push({
			type: 'text',
			text: ' ',
		});
	});

	return content;
};
